var map = {
	"./1920x1080.png": 413,
	"./1920x10801.png": 414,
	"./background1.png": 415,
	"./logo/3.png": 103,
	"./logo/Geomatix.png": 70,
	"./logo/dark.png": 416,
	"./logo/elogo.png": 71,
	"./logo/elogo1.png": 417,
	"./logo/logonav2.png": 81,
	"./logo/logonav3.png": 418,
	"./logo/past.png": 104,
	"./logo/white.png": 419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 102;